// extracted by mini-css-extract-plugin
export default {"conditions":"Authorization_conditions__m7dax","disabled":"Authorization_disabled__uLjF9"};